import {
  CREATE_STRATEGY_PACK_ERROR,
  CREATE_STRATEGY_PACK_REQUEST,
  CREATE_STRATEGY_PACK_SUCCESS,
  CREATE_WATCHLISTS_ERROR,
  CREATE_WATCHLISTS_REQUEST,
  CREATE_WATCHLISTS_SUCCESS,
  DELETE_STRATEGY_PACK_ERROR,
  DELETE_STRATEGY_PACK_REQUEST,
  DELETE_STRATEGY_PACK_SUCCESS,
  DELETE_WATCHLISTS_ERROR,
  DELETE_WATCHLISTS_REQUEST,
  DELETE_WATCHLISTS_SUCCESS,
  EDIT_STRATEGY_PACK_ERROR,
  EDIT_STRATEGY_PACK_REQUEST,
  EDIT_STRATEGY_PACK_SUCCESS,
  GET_AVAILABLE_MARKETS_ERROR_NEW,
  GET_AVAILABLE_MARKETS_REQUEST_NEW,
  GET_AVAILABLE_MARKETS_SUCCESS_NEW,
  GET_INSIGHT_CHART_DATA_ERROR,
  GET_INSIGHT_CHART_DATA_REQUEST,
  GET_INSIGHT_CHART_DATA_SUCCESS,
  GET_INSIGHT_ARTIFACTS_ERROR,
  GET_INSIGHT_ARTIFACTS_REQUEST,
  GET_INSIGHT_ARTIFACTS_SUCCESS,
  GET_INSIGHT_INITIAL_INFO_ERROR_NEW,
  GET_INSIGHT_INITIAL_INFO_REQUEST_NEW,
  GET_INSIGHT_INITIAL_INFO_SUCCESS_NEW,
  GET_STRATEGY_SIGNALS_ERRORS,
  GET_STRATEGY_SIGNALS_REQUEST,
  GET_STRATEGY_SIGNALS_SUCCESS,
  GET_SYSTEM_STRATEGY_PACK_LIST_ERROR,
  GET_SYSTEM_STRATEGY_PACK_LIST_REQUEST,
  GET_SYSTEM_STRATEGY_PACK_LIST_SUCCESS,
  GET_USER_STRATEGY_PACK_LIST_ERROR,
  GET_USER_STRATEGY_PACK_LIST_REQUEST,
  GET_USER_STRATEGY_PACK_LIST_SUCCESS,
  GET_WATCHLISTS_ERROR,
  GET_WATCHLISTS_REQUEST,
  GET_WATCHLISTS_SUCCESS,
  GET_WATCHLIST_SUMMARY_ERROR,
  GET_WATCHLIST_SUMMARY_REQUEST,
  GET_WATCHLIST_SUMMARY_SUCCESS,
  MODIFY_WATCHLISTS_ERROR,
  MODIFY_WATCHLISTS_REQUEST,
  MODIFY_WATCHLISTS_SUCCESS,
  SET_CURRENT_STRATEGY,
  SET_INSIGHT_MARKET_TYPE,
} from "./consts";
import axios from "axios";
import { axiosErrorHandler } from "../../utility/action-helper";
import alert from "../../components/alerts/Alert";
import { getLiveSuggestion } from "../live-suggestion/liveSuggestionSlice";
import { formatTelegramLog } from "../../utility/formatter-helper";
import { getAlertStrategies } from "../alert-system/actions";

const BASE_URL =
  "https://r7bphhzu5c.execute-api.us-east-1.amazonaws.com/dev/api";

export const setInsightMarketType = (market) => ({
  type: SET_INSIGHT_MARKET_TYPE,
  payload: market,
});

export const getInsightInitialDataNew =
  (
    email,
    user,
    market_type,
    only_tree_categories = "False",
    retryCount = 0,
    currentPath = window?.location?.href,
  ) =>
  async (dispatch) => {
    dispatch({ type: GET_INSIGHT_INITIAL_INFO_REQUEST_NEW });

    const data = {
      platform_mode: "insight_platform",
      email,
      user,
      market_type,
      request_type: "get_initial_info",
      only_tree_categories,
    };

    await axios
      .post(BASE_URL, data)
      .then((res) => {
        dispatch({
          type: GET_INSIGHT_INITIAL_INFO_SUCCESS_NEW,
          payload: res?.data,
        });
      })
      .catch((err) => {
        axiosErrorHandler(
          err,
          retryCount,
          dispatch,
          () =>
            getInsightInitialDataNew(
              email,
              user,
              market_type,
              only_tree_categories,
              retryCount + 1,
            ),
          GET_INSIGHT_INITIAL_INFO_ERROR_NEW,
          user,
          email,
          formatTelegramLog("insight/get_initial_info", data, BASE_URL),
          0,
          currentPath,
        );
      });
  };

export const getInsightAvailableMarkets =
  (user, email, retryCount = 0, currentPath = window?.location?.href) =>
  async (dispatch) => {
    dispatch({ type: GET_AVAILABLE_MARKETS_REQUEST_NEW });

    const data = {
      platform_mode: "insight_platform",
      email,
      user,
      request_type: "get_available_markets",
    };

    await axios
      .post(BASE_URL, data)
      .then((res) => {
        console.log(res);
        dispatch({ type: GET_AVAILABLE_MARKETS_SUCCESS_NEW });
      })
      .catch((err) => {
        axiosErrorHandler(
          err,
          retryCount,
          dispatch,
          () => getInsightAvailableMarkets(user, email, retryCount + 1),
          GET_AVAILABLE_MARKETS_ERROR_NEW,
          user,
          email,
          formatTelegramLog("insight/get_available_markets", data, BASE_URL),
          0,
          currentPath,
        );
      });
  };

export const createStrategyPack =
  (
    user,
    email,
    market_type,
    // strategy_name,
    // strategy_label,
    // strategy_tag,
    feature_list,
    extraOptions = null,
    created_date = null,
    retryCount = 0,
    currentPath = window?.location?.href,
  ) =>
  async (dispatch) => {
    dispatch({ type: CREATE_STRATEGY_PACK_REQUEST });

    let data = {
      platform_mode: "insight_platform",
      email,
      user,
      market_type,
      request_type: "create_strategy_packs",
      // strategy_name,
      feature_list,
      // strategy_label,
      // strategy_tag,
    };

    if (extraOptions) data = { ...data, ...extraOptions };
    if (created_date)
      data = {
        ...data,
        created_date,
      };

    await axios
      .post(BASE_URL, data)
      .then((res) => {
        console.log(res);
        dispatch({
          type: CREATE_STRATEGY_PACK_SUCCESS,
          payload: { message: res?.data?.message, data: res?.data?.data },
        });
        dispatch(getAlertStrategies(user, email));
        // alert("", res?.data?.message, "success", {
        //   cancel: "Close",
        // });

        dispatch(getUserStrategies(user, email, market_type));
      })
      .catch((err) => {
        axiosErrorHandler(
          err,
          retryCount,
          dispatch,
          () =>
            createStrategyPack(
              user,
              email,
              market_type,
              // strategy_name,
              feature_list,
              extraOptions,
              created_date,
              // strategy_tag,
              retryCount + 1,
            ),
          CREATE_STRATEGY_PACK_ERROR,
          user,
          email,
          formatTelegramLog("create_strategy_packs", data, BASE_URL),
          0,
          currentPath,
        );
      });
  };

export const getUserStrategies =
  (
    user,
    email,
    market_type,
    retryCount = 0,
    currentPath = window?.location?.href,
  ) =>
  async (dispatch) => {
    dispatch({ type: GET_USER_STRATEGY_PACK_LIST_REQUEST });

    const data = {
      platform_mode: "insight_platform",
      email,
      user,
      market_type,
      request_type: "get_user_strategy_packs",
    };

    await axios
      .post(BASE_URL, data)
      .then((res) => {
        dispatch({
          type: GET_USER_STRATEGY_PACK_LIST_SUCCESS,
          payload: res?.data?.data,
        });
      })
      .catch((err) => {
        axiosErrorHandler(
          err,
          retryCount,
          dispatch,
          () => getUserStrategies(user, email, market_type, retryCount + 1),
          GET_USER_STRATEGY_PACK_LIST_ERROR,
          user,
          email,
          formatTelegramLog("get_user_strategy_packs", data, BASE_URL),
          0,
          currentPath,
        );
      });
  };

export const getSystemStrategies =
  (
    user,
    email,
    market_type = "crypto",
    retryCount = 0,
    currentPath = window?.location?.href,
  ) =>
  async (dispatch) => {
    dispatch({ type: GET_SYSTEM_STRATEGY_PACK_LIST_REQUEST });

    const data = {
      platform_mode: "insight_platform",
      email,
      user,
      market_type: market_type || "crypto",
      special_strategy: "system",
      request_type: "get_user_strategy_packs",
    };

    await axios
      .post(BASE_URL, data)
      .then((res) => {
        dispatch({
          type: GET_SYSTEM_STRATEGY_PACK_LIST_SUCCESS,
          payload: res?.data?.data,
          strategyGoodness: res?.data?.strategy_goodness || {},
        });
      })
      .catch((err) => {
        axiosErrorHandler(
          err,
          retryCount,
          dispatch,
          () => getSystemStrategies(user, email, market_type, retryCount + 1),
          GET_SYSTEM_STRATEGY_PACK_LIST_ERROR,
          user,
          email,
          formatTelegramLog("get_user_strategy_packs", data, BASE_URL),
          0,
          currentPath,
        );
      });
  };

const SYSTEM_PACK_CATALOG = [
  {
    markets: ["crypto", "forex", "asx"],
    name: "Momentum",
    label: "Momentum",
    tag: ["rsi", "stochastic"],
    features: [
      ["Technical Indicators", "Momentum", "Relative Strength Index (RSI)"],
      ["Technical Indicators", "Momentum", "Stochastic Oscillator"],
      ["Technical Indicators", "Momentum", "Awesome Oscillator"],
      ["Technical Indicators", "Momentum", "Ultimate Oscillator"],
    ],
  },
  {
    markets: ["crypto", "forex", "asx"],
    name: "Trend",
    label: "Trend",
    tag: ["macd", "adx"],
    features: [
      ["Technical Indicators", "Trend", "Moving Average Convergence Divergence (MACD)"],
      ["Technical Indicators", "Trend", "Average Directional Movement Index"],
      ["Technical Indicators", "Trend", "Simple Moving Average"],
      ["Technical Indicators", "Trend", "Aroon Indicator"],
    ],
  },
  {
    markets: ["crypto", "forex", "asx"],
    name: "Volatility",
    label: "Volatility",
    tag: ["atr", "bollinger"],
    features: [
      ["Technical Indicators", "Volatility", "Average True Range"],
      ["Technical Indicators", "Volatility", "Bollinger Bands"],
      ["Technical Indicators", "Volatility", "Keltner Channel Percentage Band"],
      ["Technical Indicators", "Volatility", "Donchian Channel Band Width"],
    ],
  },
  {
    markets: ["crypto", "forex", "asx"],
    name: "Volume Flow",
    label: "Volume",
    tag: ["mfi", "obv"],
    features: [
      ["Technical Indicators", "Volume", "Money Flow Index"],
      ["Technical Indicators", "Volume", "On-balance volume"],
      ["Technical Indicators", "Volume", "Force Index"],
      ["Technical Indicators", "Volume", "Chaikin Money Flow"],
    ],
  },
  {
    markets: ["crypto", "forex", "asx"],
    name: "Price Forecast",
    label: "AI Forecast",
    tag: ["prediction"],
    features: [
      ["AI-Signal", "Predicted Price", "Next Hour Price"],
      ["AI-Signal", "Predicted Price", "Next 3 Hours Price"],
      ["AI-Signal", "Predicted Price", "Next 6 Hours Price"],
      ["AI-Signal", "Predicted Price", "Next 12 Hours Price"],
      ["AI-Signal", "Predicted Price", "Next 24 Hours Price"],
    ],
  },
  {
    markets: ["crypto"],
    name: "Rise Down",
    label: "AI Direction",
    tag: ["rise", "direction"],
    features: [
      ["AI-Signal", "RiseDown", "Rise Down (1h)"],
      ["AI-Signal", "RiseDown", "Rise Down (3h)"],
      ["AI-Signal", "RiseDown", "Rise Down (6h)"],
      ["AI-Signal", "RiseDown", "Rise Down (12h)"],
    ],
  },
  {
    markets: ["crypto"],
    name: "Pivot",
    label: "Pivot",
    tag: ["pivot"],
    features: [
      ["AI-Signal", "PivotDetection", "Pivot Detection (1h)"],
      ["AI-Signal", "PivotDetection", "Pivot Detection (3h)"],
      ["AI-Signal", "PivotDetection", "Pivot Detection (6h)"],
    ],
  },
  {
    markets: ["crypto"],
    name: "Whale Flow",
    label: "Whales",
    tag: ["whale"],
    features: [
      ["On-Chain", "Whale Analysis", "Upper 1M Whales Buy Intensity"],
      ["On-Chain", "Whale Analysis", "Upper 1M Whales Sell Intensity"],
      ["On-Chain", "Whale Analysis", "Upper 500k Whales Buy Intensity"],
      ["On-Chain", "Whale Analysis", "Upper 500k Whales Sell Intensity"],
    ],
  },
  {
    markets: ["crypto", "forex", "asx"],
    name: "On-Chain Value",
    label: "On-Chain",
    tag: ["mvrv", "sopr"],
    features: [
      ["On-Chain", "Market Value", "MVRV Z Score (USD)"],
      ["On-Chain", "Indicators", "SOPR"],
      ["On-Chain", "Supply", "Exchange Balance"],
      ["On-Chain", "Network Status", "Network Profit and Loss"],
    ],
  },
  {
    markets: ["crypto", "forex", "asx"],
    name: "Social Mood",
    label: "Sentiment",
    tag: ["sentiment", "dominance"],
    features: [
      ["Social", "Social Sentiment", "Total Balance"],
      ["Social", "Social Sentiment", "Total Positive"],
      ["Social", "Social Sentiment", "Total Negative"],
      ["Social", "Social Dominance", "Total Dominance"],
    ],
  },
  {
    markets: ["crypto", "forex", "asx"],
    name: "Rates",
    label: "Macro",
    tag: ["rates"],
    features: [
      ["Financial", "Conditions", "Interest Rate - U.S."],
      ["Financial", "Indicators", "European area Interest Rate"],
      ["Financial", "Indicators", "Treasury Interest Rate"],
      ["Financial", "Conditions", "Interest Rate - China"],
    ],
  },
  {
    markets: ["crypto", "forex", "asx"],
    name: "Dollar and FX",
    label: "FX",
    tag: ["dollar", "fx"],
    features: [
      ["Financial", "Indicators", "Nominal Broad U.S. Dollar Index"],
      ["Financial", "Indicators", "U.S. and Euro Exchange Rate"],
      ["Financial", "Indicators", "China and U.S. Exchange Rate"],
      ["Financial", "Indicators", "India and U.S. Exchange Rate"],
    ],
  },
  {
    markets: ["crypto", "forex", "asx"],
    name: "Risk Indexes",
    label: "Volatility Index",
    tag: ["vix", "risk"],
    features: [
      ["Financial", "Volatility Index", "Volatility Index"],
      ["Financial", "Volatility Index", "EuroCurrency ETF Volatility Index"],
      ["Financial", "Volatility Index", "Gold ETF Volatility Index"],
      ["Financial", "Volatility Index", "Crude Oil ETF Volatility Index"],
    ],
  },
  {
    markets: ["crypto"],
    name: "Order Flow",
    label: "Tickers",
    tag: ["order-flow"],
    features: [
      ["Market", "Tickers", "Buy Percentage"],
      ["Market", "Tickers", "Sell Percentage"],
      ["Market", "Tickers", "Buy per Sell Ratio"],
      ["Market", "Tickers", "Price Change in Percentage"],
    ],
  },
  {
    markets: ["crypto"],
    name: "Bitcoin Network",
    label: "Blockchain",
    tag: ["hashrate", "miners"],
    features: [
      ["Blockchain", "Mining Information", "Total Hash Rate (TH/s)"],
      ["Blockchain", "Mining Information", "Miners Revenue (USD)"],
      ["Blockchain", "Mining Information", "Network Difficulty"],
      ["Blockchain", "Transactions", "Confirmed Transactions Per Day"],
    ],
  },
];

const PACK_USEFULNESS = {
  "Price Forecast":
    "AI prices from the next hour through the next day. Forex and stock need this view because they do not have the crypto 15-minute pivot feed.",
  "Rise Down":
    "AI direction from 1 hour to 12 hours. Useful for seeing whether the model expects the coin higher or lower.",
  Pivot:
    "AI pivot windows on 1 hour, 3 hours, and 6 hours. Useful for spotting a turn instead of trading the middle of a move.",
  Momentum:
    "RSI and oscillators show when price is stretched or turning. Useful for timing an entry after a push instead of chasing it.",
  Trend:
    "MACD, ADX, and moving averages follow the direction. Useful when you want to stay with the move rather than fade it.",
  Volatility:
    "ATR and price bands measure how wide the swing is. Useful for placing stops and for noticing a squeeze before a break.",
  "Volume Flow":
    "Money flow and on-balance volume show whether volume agrees with the price move. Useful for skipping weak breakouts.",
  "Whale Flow":
    "Buy and sell intensity of large holders. Useful for seeing when big wallets are leaning to one side.",
  "On-Chain Value":
    "MVRV, SOPR, and exchange balances. Useful for judging whether the network looks expensive and whether coins are moving onto exchanges.",
  "Social Mood":
    "Crowd balance, positive and negative tone, and dominance. Useful as a sentiment check beside the price signals.",
  Rates:
    "US, euro-area, Treasury, and China rates. Useful because rate changes move forex pairs and risk assets.",
  "Dollar and FX":
    "The dollar index and the euro, China, and India crosses. Useful for forex direction and for crypto when the dollar is the driver.",
  "Risk Indexes":
    "Equity, euro, gold, and oil volatility. Useful for knowing when the broader market is stressed.",
  "Order Flow":
    "Buy versus sell percentage and the buy/sell ratio. Useful for a short-term read of which side is pressing.",
  "Bitcoin Network":
    "Hash rate, miner revenue, and daily transactions. Useful as a health check on Bitcoin itself.",
};

function packUsefulness(name) {
  const text = String(name || "").toLowerCase();
  const key = Object.keys(PACK_USEFULNESS)
    .sort((a, b) => b.length - a.length)
    .find((item) => text.includes(item.toLowerCase()));
  return key ? PACK_USEFULNESS[key] : "";
}

function featureLookupKey(category, subcategory, feature) {
  return [category, subcategory, feature]
    .map((part) => String(part || "").trim().toLowerCase())
    .join("\n");
}

function indexCategoryTree(tree) {
  const index = new Map();
  Object.entries(tree || {}).forEach(([category, subs]) => {
    if (!subs || typeof subs !== "object") return;
    Object.entries(subs).forEach(([subcategory, feats]) => {
      if (!feats || typeof feats !== "object") return;
      Object.entries(feats).forEach(([feature, node]) => {
        if (!node || typeof node !== "object" || !node.feature_key) return;
        const row = { category, subcategory, feature, node };
        index.set(featureLookupKey(category, subcategory, feature), row);
        if (node.name) {
          index.set(featureLookupKey(category, subcategory, node.name), row);
        }
      });
    });
  });
  return index;
}

function toPackFeature(row) {
  return {
    category: row.category,
    subcategory: row.subcategory,
    feature: row.feature,
    symbol: "",
  };
}

function packFeatures(item) {
  const raw = item?.list_feature_info;
  if (Array.isArray(raw)) return raw;
  if (typeof raw !== "string" || !raw) return [];
  try {
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed : [];
  } catch (err) {
    return [];
  }
}

function inferStrategyLabel(featureNames, features) {
  const blob = `${featureNames.join(" ")} ${features.map((item) => item?.subcategory || "").join(" ")}`;
  if (/interest|economic|inflation|gdp|sentiment/i.test(blob)) return "Macro";
  if (/bollinger|atr|volatility/i.test(blob)) return "Volatility";
  if (/rsi|stoch|cci|momentum/i.test(blob) && /macd|average|ema|sma|adx|trend/i.test(blob)) {
    return "Trend + Momentum";
  }
  if (/macd|average|ema|sma|adx|trend/i.test(blob)) return "Trend";
  if (/rsi|stoch|cci|momentum/i.test(blob)) return "Momentum";
  return features.find((item) => item?.subcategory)?.subcategory || "Signals";
}

export function presentStrategyPack(item) {
  const features = packFeatures(item);
  const featureNames = [
    ...new Set(features.map((feature) => feature?.feature).filter(Boolean)),
  ];
  const storedName = String(item?.strategy_name || "").trim();
  const genericName =
    !storedName ||
    /^(Technical|Chart|Pattern|Market|Price|Volume|Financial|Fundamental|Economic|Strategy) (Strategy|Momentum|Trend|Volatility|Predictor|Sentiment)$/.test(
      storedName,
    );
  const storedLabel = Array.isArray(item?.strategy_label)
    ? item.strategy_label.filter(Boolean).join(", ")
    : String(item?.strategy_label || "").trim();
  const storedTag = Array.isArray(item?.strategy_tag)
    ? item.strategy_tag
    : String(item?.strategy_tag || "")
        .split(",")
        .map((tag) => tag.trim())
        .filter(Boolean);
  return {
    name: genericName
      ? featureNames.slice(0, 3).join(" · ") || "Strategy"
      : storedName,
    label: storedLabel || inferStrategyLabel(featureNames, features),
    tag: storedTag.length ? storedTag : featureNames.slice(0, 3),
    description: usefulnessForItem(storedName, featureNames),
  };
}

function usefulnessForItem(storedName, featureNames) {
  const named = packUsefulness(storedName);
  if (named) return named;
  const names = new Set(featureNames.map((name) => String(name).trim().toLowerCase()));
  let best = "";
  let bestScore = 1;
  SYSTEM_PACK_CATALOG.forEach((pack) => {
    const hits = pack.features.filter(([, , feature]) =>
      names.has(String(feature).trim().toLowerCase()),
    ).length;
    if (hits > bestScore) {
      bestScore = hits;
      best = PACK_USEFULNESS[pack.name] || "";
    }
  });
  return best;
}

export function buildMarketSystemPacks(tree, market) {
  const wanted = market === "forex" || market === "asx" ? market : "crypto";
  const index = indexCategoryTree(tree);
  const prefix = wanted === "forex" ? "Forex" : wanted === "asx" ? "Stock" : "Crypto";
  return SYSTEM_PACK_CATALOG.filter((pack) => pack.markets.includes(wanted))
    .map((pack) => {
      const features = [];
      const seen = new Set();
      pack.features.forEach(([category, subcategory, feature]) => {
        const row = index.get(featureLookupKey(category, subcategory, feature));
        if (!row || seen.has(row.feature)) return;
        if (wanted !== "crypto" && /pivot/i.test(`${row.feature} ${row.node?.feature_key || ""}`)) {
          return;
        }
        seen.add(row.feature);
        features.push(toPackFeature(row));
      });
      if (features.length < 2) return null;
      return {
        name: `${prefix} ${pack.name}`,
        label: pack.label,
        tag: pack.tag,
        description: PACK_USEFULNESS[pack.name] || "",
        features,
      };
    })
    .filter(Boolean);
}

const seededSystemPackNames = new Set();
let systemPackSeedInFlight = false;

export const seedMarketSystemStrategies =
  (user, email) => async (dispatch, getState) => {
    if (systemPackSeedInFlight) return;
    const insight = getState()?.newInsightState || {};
    const selected = insight.insightMarketType || "crypto";
    const market = selected === "forex" || selected === "asx" ? selected : "crypto";
    const packs = buildMarketSystemPacks(insight.categoriesFeatureTree, market);
    const existingNames = new Set();
    (insight.systemStrategies || []).forEach((item) => {
      if ((item?.market_type || "crypto") !== market) return;
      existingNames.add(String(item?.strategy_name || "").trim().toLowerCase());
      existingNames.add(presentStrategyPack(item).name.toLowerCase());
    });
    const missing = packs.filter((pack) => {
      const key = `${market}:${pack.name.toLowerCase()}`;
      return !existingNames.has(pack.name.toLowerCase()) && !seededSystemPackNames.has(key);
    });
    if (!missing.length) return;

    systemPackSeedInFlight = true;
    missing.forEach((pack) => seededSystemPackNames.add(`${market}:${pack.name.toLowerCase()}`));
    try {
      for (const pack of missing) {
        await axios.post(BASE_URL, {
          platform_mode: "insight_platform",
          email,
          user,
          market_type: market,
          special_strategy: "system",
          request_type: "create_strategy_packs",
          feature_list: pack.features,
          strategy_name: pack.name,
          strategy_label: pack.label,
          strategy_tag: pack.tag,
          strategy_description: pack.description,
        });
      }
    } catch (err) {
      // A later pack can fail after earlier ones were saved.
    }
    try {
      await dispatch(getSystemStrategies(user, email, market));
    } finally {
      systemPackSeedInFlight = false;
    }
  };

export const editStrategy =
  (
    user,
    email,
    created_date,
    fields_to_edit,
    attribute_values_to_edit,
    showNotif = true,
    retryCount = 0,
    currentPath = window?.location?.href,
  ) =>
  async (dispatch) => {
    dispatch({ type: EDIT_STRATEGY_PACK_REQUEST });

    const data = {
      platform_mode: "insight_platform",
      email,
      user,
      request_type: "edit_user_strategy_pack",
      created_date,
      fields_to_edit,
      attribute_values_to_edit,
    };

    await axios
      .post(BASE_URL, data)
      .then((res) => {
        console.log(res);
        dispatch({ type: EDIT_STRATEGY_PACK_SUCCESS });
        if (showNotif) {
          alert("", res?.data?.message, "success", {
            cancel: "Close",
          });
        }
        dispatch(getAlertStrategies(user, email));

        dispatch(getUserStrategies(user, email, "crypto"));
      })
      .catch((err) => {
        axiosErrorHandler(
          err,
          retryCount,
          dispatch,
          () =>
            editStrategy(
              user,
              email,
              created_date,
              fields_to_edit,
              attribute_values_to_edit,
              showNotif,
              retryCount + 1,
            ),
          EDIT_STRATEGY_PACK_ERROR,
          user,
          email,
          formatTelegramLog("edit_user_strategy_pack", data, BASE_URL),
          0,
          currentPath,
        );
      });
  };

export const deleteStrategy =
  (
    user,
    email,
    created_date,
    retryCount = 0,
    currentPath = window?.location?.href,
  ) =>
  async (dispatch) => {
    dispatch({ type: DELETE_STRATEGY_PACK_REQUEST });

    const data = {
      platform_mode: "insight_platform",
      email,
      user,
      request_type: "delete_strategy_packs",
      created_date,
    };

    await axios
      .post(BASE_URL, data)
      .then((res) => {
        console.log(res);
        dispatch({
          type: DELETE_STRATEGY_PACK_SUCCESS,
          payload: res?.data?.message,
        });
        alert("", res?.data?.message, "success", {
          cancel: "Close",
        });
        dispatch(getAlertStrategies(user, email));

        dispatch(getUserStrategies(user, email, "crypto"));
      })
      .catch((err) => {
        axiosErrorHandler(
          err,
          retryCount,
          dispatch,
          () => deleteStrategy(user, email, created_date, retryCount + 1),
          DELETE_STRATEGY_PACK_ERROR,
          user,
          email,
          formatTelegramLog("delete_strategy_packs", data, BASE_URL),
          0,
          currentPath,
        );
      });
  };

export const getStrategySignal =
  (
    user,
    email,
    created_date,
    isSystem = false,
    isActive = false,
    market_type = "crypto",
    retryCount = 0,
    currentPath = window?.location?.href,
  ) =>
  async (dispatch) => {
    dispatch({ type: GET_STRATEGY_SIGNALS_REQUEST });

    let data = {
      platform_mode: "insight_platform",
      email,
      user,
      request_type: "query_signals_strategy_packs",
      created_date,
      market_type: market_type || "crypto",
    };

    if (isSystem) data["special_strategy"] = "system";

    await axios
      .post(BASE_URL, data)
      .then((res) => {
        console.log(res);
        dispatch({ type: GET_STRATEGY_SIGNALS_SUCCESS, payload: res?.data });

        // const signals = res?.data?.signals;

        // if (signals?.length > 0) {
        //   signals?.map((s) =>
        //     dispatch(getLiveSuggestion(user, email, "kucoin", s?.coin)),
        //   );
        // }
      })
      .catch((err) => {
        axiosErrorHandler(
          err,
          retryCount,
          dispatch,
          () =>
            getStrategySignal(
              user,
              email,
              created_date,
              isSystem,
              isActive,
              market_type,
              retryCount + 1,
            ),
          GET_STRATEGY_SIGNALS_ERRORS,
          user,
          email,
          formatTelegramLog("query_signals_strategy_packs", data, BASE_URL),
          0,
          currentPath,
        );
      });
  };

export const getInsightArtifacts =
  (
    user,
    email,
    chartId,
    liveSnapshot = [],
    retryCount = 0,
    currentPath = window?.location?.href,
  ) =>
  async (dispatch, getState) => {
    if (!chartId) return;
    if (getState().newInsightState.chartId !== chartId) return;

    dispatch({ type: GET_INSIGHT_ARTIFACTS_REQUEST, payload: chartId });

    const data = {
      platform_mode: "insight_platform",
      email,
      user,
      request_type: "get_insight_artifacts",
      chart_id: chartId,
      live_snapshot: liveSnapshot,
      market_type: getState().newInsightState.insightMarketType || "crypto",
    };
    const browserLang = String(navigator.language || "").toLowerCase();
    data.lang = browserLang.startsWith("fa")
      ? "fa"
      : browserLang.startsWith("id")
        ? "id"
        : "en";

    await axios
      .post(BASE_URL, data)
      .then((res) => {
        if (getState().newInsightState.chartId !== chartId) return;
        if (res?.data?.status === "error") {
          dispatch({
            type: GET_INSIGHT_ARTIFACTS_ERROR,
            payload: `${res?.data?.message || "Couldn't load the summary."} [${BASE_URL}]`,
          });
          return;
        }
        dispatch({
          type: GET_INSIGHT_ARTIFACTS_SUCCESS,
          payload: {
            chartId: res?.data?.chart_id || chartId,
            insightSummary: res?.data?.insight_summary || {},
            exportLinks: res?.data?.export_links || {},
            visualSummary: res?.data?.visual_summary || {},
          },
        });
      })
      .catch((err) => {
        if (getState().newInsightState.chartId !== chartId) return;
        axiosErrorHandler(
          err,
          retryCount,
          dispatch,
          () => getInsightArtifacts(user, email, chartId, liveSnapshot, retryCount + 1),
          GET_INSIGHT_ARTIFACTS_ERROR,
          user,
          email,
          formatTelegramLog("get_insight_artifacts", data, BASE_URL),
          0,
          currentPath,
        );
      });
  };

export const getChartData =
  (
    user,
    email,
    symbol,
    indicator,
    chart_id,
    retryCount = 0,
    currentPath = window?.location?.href,
  ) =>
  async (dispatch) => {
    dispatch({ type: GET_INSIGHT_CHART_DATA_REQUEST });

    const data = {
      platform_mode: "insight_platform",
      email,
      user,
      request_type: "get_chart_data",
      chart_id,
      symbol,
      indicator,
    };

    await axios
      .post(BASE_URL, data)
      .then((res) => {
        if (res?.data?.status === "error") {
          dispatch({
            type: GET_INSIGHT_CHART_DATA_ERROR,
            payload: `${res?.data?.message || "Couldn't load the chart."} [${BASE_URL}]`,
          });
          return;
        }
        console.log(res);
        dispatch({ type: GET_INSIGHT_CHART_DATA_SUCCESS, payload: res?.data });
      })
      .catch((err) => {
        axiosErrorHandler(
          err,
          retryCount,
          dispatch,
          () =>
            getChartData(
              user,
              email,
              symbol,
              indicator,
              chart_id,
              retryCount + 1,
            ),
          GET_INSIGHT_CHART_DATA_ERROR,
          user,
          email,
          formatTelegramLog("insight/get_chart_data", data, BASE_URL),
          0,
          currentPath,
        );
      });
  };

export const setCurrentStrategy = (strategyInfo) => (dispatch) => {
  dispatch({ type: SET_CURRENT_STRATEGY, payload: strategyInfo });
};

export const getWatchLists =
  (user, email, retryCount = 0, currentPath = window?.location?.href) =>
  async (dispatch) => {
    dispatch({ type: GET_WATCHLISTS_REQUEST });

    const url =
      "https://r7bphhzu5c.execute-api.us-east-1.amazonaws.com/dev/api";
    const data = {
      request_type: "list_watchlists",
      platform_mode: "insight_platform",
      user,
      email,
    };

    await axios
      .post(url, data)
      .then((res) => {
        dispatch({
          type: GET_WATCHLISTS_SUCCESS,
          payload: res?.data?.watchlists,
        });
      })
      .catch((err) => {
        axiosErrorHandler(
          err,
          retryCount,
          dispatch,
          () => getWatchLists(user, email, retryCount + 1),
          GET_WATCHLISTS_ERROR,
          user,
          email,
          formatTelegramLog("list_watchlists", data, url),
          0,
          currentPath,
        );
      });
  };

export const createWatchList =
  (
    user,
    email,
    list_of_coins,
    showNotif = true,
    retryCount = 0,
    currentPath = window?.location?.href,
  ) =>
  async (dispatch) => {
    dispatch({ type: CREATE_WATCHLISTS_REQUEST });

    const url =
      "https://r7bphhzu5c.execute-api.us-east-1.amazonaws.com/dev/api";
    const data = {
      request_type: "create_watchlist",
      platform_mode: "insight_platform",
      user,
      email,
      list_of_coins,
    };

    await axios
      .post(url, data)
      .then((res) => {
        dispatch({
          type: CREATE_WATCHLISTS_SUCCESS,
          payload: res?.data?.message,
        });
        if (showNotif) {
          alert("", res?.data?.message, "success", {
            cancel: "Close",
          });
        }
        dispatch(getWatchLists(user, email));
      })
      .catch((err) => {
        axiosErrorHandler(
          err,
          retryCount,
          dispatch,
          () =>
            createWatchList(
              user,
              email,
              list_of_coins,
              showNotif,
              retryCount + 1,
            ),
          CREATE_WATCHLISTS_ERROR,
          user,
          email,
          formatTelegramLog("create_watchlist", data, url),
          0,
          currentPath,
        );
      });
  };

export const deleteWatchlist =
  (
    user,
    email,
    created_date,
    showNotif = true,
    retryCount = 0,
    currentPath = window?.location?.href,
  ) =>
  async (dispatch) => {
    dispatch({ type: DELETE_WATCHLISTS_REQUEST });

    const url =
      "https://r7bphhzu5c.execute-api.us-east-1.amazonaws.com/dev/api";
    const data = {
      request_type: "delete_watchlist",
      platform_mode: "insight_platform",
      user,
      email,
      created_date,
    };

    await axios
      .post(url, data)
      .then((res) => {
        dispatch({
          type: DELETE_WATCHLISTS_SUCCESS,
          payload: res?.data?.message,
        });
        if (showNotif) {
          alert("", res?.data?.message, "success", {
            cancel: "Close",
          });
        }
        dispatch(getWatchLists(user, email));
      })
      .catch((err) => {
        axiosErrorHandler(
          err,
          retryCount,
          dispatch,
          () =>
            deleteWatchlist(
              user,
              email,
              created_date,
              showNotif,
              retryCount + 1,
            ),
          DELETE_WATCHLISTS_ERROR,
          user,
          email,
          formatTelegramLog("delete_watchlist", data, url),
          0,
          currentPath,
        );
      });
  };

export const modifyWatchlist =
  (
    user,
    email,
    created_date,
    list_of_coins,
    showNotif = true,
    retryCount = 0,
    currentPath = window?.location?.href,
  ) =>
  async (dispatch) => {
    dispatch({ type: MODIFY_WATCHLISTS_REQUEST });

    const url =
      "https://r7bphhzu5c.execute-api.us-east-1.amazonaws.com/dev/api";
    const data = {
      request_type: "modify_watchlist",
      platform_mode: "insight_platform",
      user,
      email,
      created_date,
      updated_data: {
        list_of_coins,
      },
    };

    await axios
      .post(url, data)
      .then((res) => {
        console.log(res);
        dispatch({
          type: MODIFY_WATCHLISTS_SUCCESS,
          payload: res?.data?.message,
        });
        if (showNotif) {
          alert("", res?.data?.message, "success", {
            cancel: "Close",
          });
        }
        dispatch(getWatchLists(user, email));
      })
      .catch((err) => {
        axiosErrorHandler(
          err,
          retryCount,
          dispatch,
          () =>
            modifyWatchlist(
              user,
              email,
              created_date,
              list_of_coins,
              showNotif,
              retryCount + 1,
            ),
          MODIFY_WATCHLISTS_ERROR,
          user,
          email,
          formatTelegramLog("modify_watchlist", data, url),
          0,
          currentPath,
        );
      });
  };

function readWatchlistSummary(payload) {
  let data = payload || {};
  if (typeof data?.body === "string") {
    try {
      data = JSON.parse(data.body);
    } catch {
      data = payload || {};
    }
  }
  if (!data || typeof data !== "object") return {};
  if (data.replaced === "True") return { ...data, replaced: true };
  return data;
}

export const getWatchlistSummary =
  (
    user,
    email,
    replaceWatchlist = false,
    retryCount = 0,
    currentPath = window?.location?.href,
  ) =>
  async (dispatch) => {
    dispatch({
      type: GET_WATCHLIST_SUMMARY_REQUEST,
      payload: { replace: replaceWatchlist },
    });

    const url =
      "https://r7bphhzu5c.execute-api.us-east-1.amazonaws.com/dev/api";
    const data = {
      request_type: "get_watchlist_summary",
      platform_mode: "insight_platform",
      user,
      email,
    };
    if (replaceWatchlist) {
      data.replace_watchlist = "True";
    }

    await axios
      .post(url, data)
      .then((res) => {
        const body = readWatchlistSummary(res?.data);
        if (body?.status === "error" || (replaceWatchlist && !body?.replaced)) {
          dispatch({
            type: GET_WATCHLIST_SUMMARY_ERROR,
            payload:
              body?.message ||
              (replaceWatchlist
                ? "The watchlist was not saved."
                : "Couldn't load the watchlist summary."),
          });
          return;
        }
        if (!body?.summary && !Array.isArray(body?.suggested_coins)) {
          dispatch({
            type: GET_WATCHLIST_SUMMARY_ERROR,
            payload: body?.message || "Couldn't load the watchlist summary.",
          });
          return;
        }
        dispatch({
          type: GET_WATCHLIST_SUMMARY_SUCCESS,
          payload: body,
        });
        if (replaceWatchlist) {
          dispatch(getWatchLists(user, email));
        }
      })
      .catch((err) => {
        axiosErrorHandler(
          err,
          retryCount,
          dispatch,
          () =>
            getWatchlistSummary(
              user,
              email,
              replaceWatchlist,
              retryCount + 1,
            ),
          GET_WATCHLIST_SUMMARY_ERROR,
          user,
          email,
          formatTelegramLog("get_watchlist_summary", data, url),
          0,
          currentPath,
        );
      });
  };
